import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { ExhibitorDto } from '@/shared/types/domain';

export const exhibitorsApi = {
  getById: (exhibitorId: string) => httpClient.get<ExhibitorDto>(endpoints.exhibitors.byId(exhibitorId))
};
